// 1. React and fabric. 
import { RouteComponentProps } from '../Router5';
// 2. Store and Types. 

export default interface IDashletProps extends RouteComponentProps<any>
{
	ID               : string;
	TITLE            : string;
	SETTINGS_EDITVIEW: any;
	DEFAULT_SETTINGS : any;
	COLUMN_WIDTH     : number  ; // bootstrap 1 to 12. 
}

